import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import BrandLogo from '../components/BrandLogo';
import './Auth.css';

const API = process.env.REACT_APP_API_URL || 'http://localhost:4000';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [form, setForm] = useState({ password: '', confirm: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const change = event => setForm(current => ({ ...current, [event.target.name]: event.target.value }));

  const submit = async event => {
    event.preventDefault();
    setError('');
    if (form.password !== form.confirm) return setError('Passwords do not match.');
    setLoading(true);
    try {
      const response = await fetch(`${API}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password: form.password }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Password reset failed.');
      setSuccess(data.message);
    } catch (requestError) {
      setError(requestError.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-root">
      <div className="auth-bg" />
      <div className="auth-card glass">
        <Link to="/login" className="auth-back">← Back to sign in</Link>
        <BrandLogo className="auth-logo" />
        <h1 className="auth-title">Choose a new password</h1>
        <p className="auth-sub">Use at least eight characters.</p>

        {error && <div className="auth-error">{error}</div>}
        {success ? (
          <div className="auth-reset-result">
            <div className="auth-success">{success}</div>
            <Link className="auth-btn auth-btn-link" to="/login">Return to Sign In</Link>
          </div>
        ) : (
          <form className="auth-form" onSubmit={submit} noValidate>
            <div className="auth-field">
              <label htmlFor="new-password">New Password</label>
              <input id="new-password" name="password" type="password" value={form.password} onChange={change} autoComplete="new-password" required />
            </div>
            <div className="auth-field">
              <label htmlFor="confirm-password">Confirm Password</label>
              <input id="confirm-password" name="confirm" type="password" value={form.confirm} onChange={change} autoComplete="new-password" required />
            </div>
            <button className="auth-btn" type="submit" disabled={loading || !token}>
              {loading ? <span className="auth-spinner" /> : 'Update Password'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}